
import RecursiveTaxonomyGroup from '@/components/RecursiveTaxonomyGroup.vue';
import { defineComponent } from "vue";

export default defineComponent({
	name: 'TaxonomyDropdown',
	props: {
		availableTaxonomyTerms: {
			required: true,
			type: Object
		},
	},
	components: {
		RecursiveTaxonomyGroup
	},
	inject: [
		'useToggleSubstitutes'
	],
	emits: ['updateTaxonomy', 'closeAllDropdowns'],
	expose: ['reset', 'closeAllDropdowns'],
	data() {
		return {
			toggles: {} as { [key: string]: boolean },
		}
	},
	methods: {
		componentId(append: string) {
			return 'vueEventsPlugin' + append
		},
		updateTaxonomy(taxonomy: string, termId: number) {
			this.$emit('updateTaxonomy', taxonomy, termId)
		},
		reset() {
			if (this.$refs.recursiveTaxonomyGroup) {
				(this.$refs.recursiveTaxonomyGroup as Array<object>).forEach((group: object) => {
					(group as InstanceType<typeof RecursiveTaxonomyGroup>).reset();
				});
			}
		},
		toggleDropdown(e: Event, slug: string) {
			if (false === this.useToggleSubstitutes) {
				return
			}

			let currentState = (this.toggles[slug] && true === this.toggles[slug]) ? true : false
			this.closeAllDropdowns(true)
			this.toggles[slug] = !currentState
			e.stopPropagation()
		},
		closeAllDropdowns(emit = false) {
			Object.keys(this.availableTaxonomyTerms).forEach((k) => {
				if (this.toggles[k]) {
					this.toggles[k] = false
				}
			})
			if (emit) {
				this.$emit('closeAllDropdowns')
			}
		}
	},
	mounted() {
		if (true === this.useToggleSubstitutes) {
			document.body.addEventListener('click', () => {
				this.closeAllDropdowns(true)
			})
			Object.keys(this.availableTaxonomyTerms).forEach((k) => {
				const elementId = this.componentId('TaxField' + k + 'Dropdown')
				const element = document.getElementById(elementId)
				if (element) {
					element.addEventListener('click', (e) => {
						e.stopPropagation()
					})
				}
			})
		}
	}
})
